import { useNavigate, Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Loading from "../components/LoadingScreen";

import regada_picture from "../images/logoTYPOGRAPHIA.svg";
import first_landing from "../images/pexels-chevanon-1108101.jpg";
import second_landing from "../images/pexels-pixabay-159298.jpg";

import OtpInput from "react-otp-input";

import axios from "axios";

const Selector = () => {
  const serverAdresa = process.env.REACT_APP_API_URL;

  const jazyky = ["SK", "EN", "RU"];

  const [selectedLanguage, setSelectedLanguage] = useState("SK");

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value); // Pass the selected language back to the parent component
  };

  let navigate = useNavigate();
  const [typove, setTypove] = useState("260");
  const [vsetkyServopohony, setVsetkyServopohony] = useState(null);
  const [vsetkyServopohonyMena, setVsetkyServopohonyMena] = useState(null);

  const [jeObchodak, setJeObchodak] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [otp, setOtp] = useState("");

  const handleClickModal = () => {
    setOtp("");
    setShowModal(!showModal);
  };

  const handleKeyDown = (event) => {
    console.log("a");
    if (event.key === "Enter") {
      handlePINCheck();
    }
  };

  async function handlePINCheck() {
    try {
      const res = await axios.post(`${serverAdresa}verify-pin`, { pin: otp });

      if (res.data?.success) {
        console.log("dobre");
        setShowModal(false);
        setJeObchodak(true);
      } else {
        console.log("Invalid PIN");
      }
    } catch (e) {
      console.log(e);
    }
  }

  const obchodak = true;

  const prveSpustenie = useRef(false);

  async function getAllServa() {
    try {
      const response = await axios.get(`${serverAdresa}vsetko`);
      setVsetkyServopohony(response.data.map((item) => item.kod));
      setVsetkyServopohonyMena(response.data.map((item) => item.nazov));
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (prveSpustenie.current === false) {
      getAllServa();
      return () => (prveSpustenie.current = true);
    }
  }, []);

  return (
    <>
      {vsetkyServopohony && vsetkyServopohonyMena && (
        <>
          <div className={showModal ? "zoslabenie" : ""}>
            <div className="hlavnyLanding">
              <div className="navLanding">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "20px",
                    borderBottom: "1px solid #E8E6E2",
                  }}
                >
                  <img
                    src={regada_picture}
                    id="typografia_header"
                    alt="typography"
                  ></img>
                  <div>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button
                        className="button-18"
                        onClick={handleClickModal}
                        style={{ backgroundColor: "#141414" }}
                      >
                        Obchodné
                      </button>
                      <button
                        className="button-18"
                        onClick={() => navigate("/menu")}
                      >
                        {selectedLanguage === "EN"
                          ? "Employees"
                          : selectedLanguage === "RU"
                          ? "Сотрудники"
                          : "Zamestnanci"}
                      </button>
                      <select
                        value={selectedLanguage}
                        onChange={handleLanguageChange}
                        name="language"
                        id="language_header"
                      >
                        {jazyky.map((e) => {
                          return <option value={e}>{e}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "70px",
                  gap: "60px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "start",
                    gap: "20px",
                  }}
                >
                  <button className="button-19">
                    {selectedLanguage === "EN"
                      ? "New on the market"
                      : selectedLanguage === "RU"
                      ? "Новое на рынке"
                      : "Novinka na trhu"}
                  </button>
                  <h1 className="landingHeadline">
                    {selectedLanguage === "EN"
                      ? "Modern services for customers"
                      : selectedLanguage === "RU"
                      ? "Современные услуги для клиентов"
                      : "Moderné služby pre zákazníkov"}
                  </h1>
                  <p
                    style={{
                      fontSize: "16px",
                      width: "420px",
                      color: "#71726E",
                    }}
                  >
                    {selectedLanguage === "EN"
                      ? "Try out new functionalities such as the interactive configurator, order code decipherer or diagram generator."
                      : selectedLanguage === "RU"
                      ? "Попробуйте новые функции, такие как интерактивный конфигуратор, расшифровщик кода заказа или генератор диаграмм."
                      : "Vyskúšajte si nové funkcionality ako interaktívny konfigurátor, dešifrovač objednávacieho kódu alebo generátor schém."}
                  </p>
                  <div className="buttony" style={{ alignItems: "flex-start" }}>
                    <Box sx={{ maxWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          {selectedLanguage === "EN"
                            ? "Number"
                            : selectedLanguage === "RU"
                            ? "Число"
                            : "Typové"}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={typove}
                          label="Typove"
                          onChange={(e) => {
                            setTypove(e.target.value);
                          }}
                        >
                          {vsetkyServopohony.map((e) => {
                            return <MenuItem value={e}>{e}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {!jeObchodak && (
                        <button
                          className="button-18"
                          onClick={() => {
                            navigate(`/serva/${typove}`, {
                              state: {
                                selectedLanguage,
                              },
                            });
                          }}
                        >
                          {selectedLanguage === "EN"
                            ? "Configure"
                            : selectedLanguage === "RU"
                            ? "Настроить"
                            : "Konfigurovať"}{" "}
                          {
                            vsetkyServopohonyMena[
                              vsetkyServopohony.indexOf(typove)
                            ]
                          }
                        </button>
                      )}
                      {jeObchodak && (
                        <button
                          className="button-18"
                          onClick={() => {
                            navigate(`/serva/${typove}`, {
                              state: {
                                selectedLanguage,
                                obchodak,
                              },
                            });
                          }}
                          style={{ backgroundColor: "#141414" }}
                        >
                          {selectedLanguage === "EN"
                            ? "Configure"
                            : selectedLanguage === "RU"
                            ? "Настроить"
                            : "Konfigurovať"}{" "}
                          {
                            vsetkyServopohonyMena[
                              vsetkyServopohony.indexOf(typove)
                            ]
                          }
                        </button>
                      )}
                    </div>

                    <button
                      className="button-18"
                      onClick={() => navigate("/search")}
                    >
                      {selectedLanguage === "EN"
                        ? "Decipherer"
                        : selectedLanguage === "RU"
                        ? "Дешифратор"
                        : "Dešifrovač"}
                    </button>

                    <button
                      className="button-18"
                      onClick={() => navigate("/schemy")}
                    >
                      {selectedLanguage === "EN"
                        ? "Diagrams"
                        : selectedLanguage === "RU"
                        ? "Схема"
                        : "Schémy"}
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    position: "relative",
                    width: "460px",
                    height: "auto",
                    marginTop: "30px",
                  }}
                >
                  <img
                    src={first_landing}
                    alt="f"
                    style={{
                      width: "460px",
                      position: "absolute",
                      top: "0",
                      left: "0",
                    }}
                  />
                  <img
                    src={second_landing}
                    alt="f"
                    style={{
                      width: "200px",
                      position: "absolute",
                      top: "200px",
                      left: "300px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {showModal && (
            <div
              className="auth-modal"
              style={{ height: "200px", maxWidth: "max-content" }}
            >
              <div className="close-icon" onClick={handleClickModal}>
                ✖
              </div>
              <div
                id="nadpis_form"
                style={{ marginBottom: "10px", paddingBottom: "20px" }}
              >
                PIN k obchodnému kontu
              </div>

              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => (
                  <input
                    {...props}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handlePINCheck();
                    }}
                  />
                )}
                inputStyle={{
                  width: "3rem",
                  height: "3rem",
                  margin: "0 0.5rem",
                  borderRadius: "25%",
                  border: "2px solid #005e9d",
                  textAlign: "center",
                  fontSize: "1.5rem",
                  outline: "none",
                  transition: "0.2s ease",
                }}
              />

              <div
                className="tlacitka-formular"
                style={{ justifyContent: "start" }}
              >
                <button
                  className="tlacitko"
                  onClick={handleClickModal}
                  style={{ padding: "10px 0 10px 0", width: "180px" }}
                >
                  ←{" "}
                  {selectedLanguage === "EN"
                    ? "Back"
                    : selectedLanguage === "RU"
                    ? "Назад"
                    : "Naspäť"}
                </button>

                <button
                  className="tlacitko"
                  style={{ padding: "10px 0 10px 0", width: "180px" }}
                  onClick={handlePINCheck}
                >
                  {selectedLanguage === "EN"
                    ? "Continue"
                    : selectedLanguage === "RU"
                    ? "Продолжать"
                    : "Potvrď"}{" "}
                  →
                </button>
              </div>
            </div>
          )}
        </>
      )}
      {!vsetkyServopohony && !vsetkyServopohonyMena && <Loading />}
    </>
  );
};

export default Selector;
